import { ApiClient } from '@webapp/core/services/ApiClient'
import { PDFLabelSetRepository } from './PDFLabelSetRepository'

export const pdfLabelSetRepository = new PDFLabelSetRepository({
  httpClient: ApiClient,
})

export * from './PDFLabelSetRepository'
